export default __webpack_public_path__ + "static/media/xdc-icon.91433213.png";